// extracted by mini-css-extract-plugin
module.exports = {"badgeAds":"BadgeAds__badgeAds___3SUFw","badgeAd":"BadgeAds__badgeAd___JnhfS"};